import React from "react";
import { motion } from "framer-motion";

const CallToAction = () => {
    return (
        <div className="cta-section">
            <motion.div
                className="cta-content"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
            >
                <h2 className="cta-heading">
                    Ready to Find the Right Talent for Your Business?<br />
                    <span> Contact Us Today for a Free Consultation!</span>
                </h2>

                {/* CTA Buttons Section */}
                <div className="cta-buttons">
                    <motion.a
                        className="cta-button cta-call"
                        href="tel:+917208328645"
                        whileTap={{ scale: 0.95 }}
                    >
                        Call Us Now
                    </motion.a>
                </div>
            </motion.div>
        </div>
    );
};

export default CallToAction;
